import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { Button, ButtonGroup, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";
import ReactTable from "react-table";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
    getPayRateOverrides,
    deletePayRateOverrideSingle
} from "api/menu/master-files/workers-maintenance/actions";

const ModalPayrateOverrides = React.lazy(() =>
    import("components/menu/master-files/workers-maintenance/worker-profile-components/modal-payrate-overrides"));

class TabWorkerPayroll extends React.Component {
    constructor(props) {
        super(props);

        this.handleModalSinglePayRateOverrides = this.handleModalSinglePayRateOverrides.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        if (this.props.workerId) {
            this.props.getPayRateOverrides(this.props.workerId);
        }
    }

    handleDelete = (employeeId, payRateOverrideID) => {
        this.props.deletePayRateOverrideSingle(employeeId, payRateOverrideID);
    };

    handleModalSinglePayRateOverrides = (payRateOverrideID = false) => {
        const modalTitle = payRateOverrideID !== false ? "Update" : "Create";

        const modalObj = {
            id: "handleModalSinglePayRateOverrides",
            header: `${modalTitle} Pay Rate Override`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ModalPayrateOverrides
                        employeeId={this.props.workerId}
                        payRateOverrideID={payRateOverrideID}
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        onSave={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            isEditable,
            payRateOverrides,
            workerId
        } = this.props;

        return (
            <div className="container mt-3">
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-0">
                            <Form.Label className="col-6 text-right mr-2">
                                Payroll Input Method
                            </Form.Label>
                            <div className="col-6">
                                <div className="row">
                                    <div className="col-6">
                                        <Form.Check
                                            type="radio"
                                            label="Online"
                                            checked={this.props.getEmployeeValue(
                                                "isOnlinePayrol",
                                                this.props.tabKey
                                            ) === true}
                                            readOnly={!isEditable}
                                            name="isOnlinePayrol"
                                            value={true}
                                            onChange={() => {
                                                if (!isEditable) {
                                                    return;
                                                }
                                                this.props.onChange({
                                                    target: {
                                                        name: "isOnlinePayrol",
                                                        value: true
                                                    }
                                                }, this.props.tabKey);
                                            }}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Form.Check
                                            type="radio"
                                            label="Manual"
                                            checked={this.props.getEmployeeValue(
                                                "isOnlinePayrol",
                                                this.props.tabKey
                                            ) === false}
                                            readOnly={!isEditable}
                                            name="isOnlinePayrol"
                                            value={false}
                                            onChange={() => {
                                                if (!isEditable) {
                                                    return;
                                                }
                                                this.props.onChange({
                                                    target: {
                                                        name: "isOnlinePayrol",
                                                        value: false
                                                    }
                                                }, this.props.tabKey);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-6 text-right pr-5">
                        <div className="pr-5">
                            Travel Rate Overrides
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-0">
                            <Form.Label className="col-6 text-right mr-2">
                                Is Payroll On Hold?
                            </Form.Label>
                            <div className="col-6">
                                <Form.Check
                                    type="checkbox"
                                    label="Yes"
                                    checked={this.props.getEmployeeValue(
                                        "isPayrollOnHold",
                                        this.props.tabKey
                                    )}
                                    readOnly={!isEditable}
                                    name="isPayrollOnHold"
                                    onChange={() => {
                                        if (!isEditable) {
                                            return;
                                        }
                                        this.props.onChange({
                                            target: {
                                                name: "isPayrollOnHold",
                                                value: !this.props.getEmployeeValue("isPayrollOnHold", this.props.tabKey)
                                            }
                                        }, this.props.tabKey);
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                High Km
                            </Form.Label>
                            <Form.Control
                                type="number"
                                min={0}
                                step={0.1}
                                readOnly={!isEditable}
                                name="travelHighKmRate"
                                value={this.props.getEmployeeValue("travelHighKmRate", this.props.tabKey) || ""}
                                onChange={ev => {
                                    this.props.onChange({
                                        target: {
                                            name: ev.target.name,
                                            value: parseFloat(ev.target.value)
                                        }
                                    }, this.props.tabKey);
                                }}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-0">
                            <Form.Label className="col-6 text-right mr-2">
                                Is GST Applicable?
                            </Form.Label>
                            <div className="col-6">
                                <Form.Check
                                    type="checkbox"
                                    label="Yes"
                                    checked={this.props.getEmployeeValue(
                                        "isGstApplicable",
                                        this.props.tabKey
                                    )}
                                    readOnly={!isEditable}
                                    name="isGstApplicable"
                                    onChange={() => {
                                        if (!isEditable) {
                                            return;
                                        }
                                        this.props.onChange({
                                            target: {
                                                name: "isGstApplicable",
                                                value: !this.props.getEmployeeValue("isGstApplicable", this.props.tabKey)
                                            }
                                        }, this.props.tabKey);
                                    }}
                                />
                            </div>
                        </Form.Group>
                    </div>
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Low Km
                            </Form.Label>
                            <Form.Control
                                type="number"
                                min={0}
                                step={0.1}
                                readOnly={!isEditable}
                                name="travelLowKmRate"
                                value={this.props.getEmployeeValue("travelLowKmRate", this.props.tabKey) || ""}
                                onChange={ev => {
                                    this.props.onChange({
                                        target: {
                                            name: ev.target.name,
                                            value: parseFloat(ev.target.value)
                                        }
                                    }, this.props.tabKey);
                                }}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 offset-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline">
                            <Form.Label className="col-6 text-right mr-2">
                                Per Hour
                            </Form.Label>
                            <Form.Control
                                type="number"
                                min={0}
                                step={0.1}
                                readOnly={!isEditable}
                                name="travelPerHourRate"
                                value={this.props.getEmployeeValue("travelPerHourRate", this.props.tabKey) || ""}
                                onChange={ev => {
                                    this.props.onChange({
                                        target: {
                                            name: ev.target.name,
                                            value: parseFloat(ev.target.value)
                                        }
                                    }, this.props.tabKey);
                                }}
                            />
                        </Form.Group>
                    </div>
                </div>
                {workerId > 0 ?
                    <div className="mt-3 mb-3">
                        <div className="clearfix">
                            <button
                                className="btn btn-warning float-right mb-2"
                                onClick={() => this.handleModalSinglePayRateOverrides()}
                            >
                                Add Record
                            </button>
                        </div>
                        <ReactTable
                            data={payRateOverrides}
                            headerClassName="table-header"
                            columns={[
                                {
                                    headerClassName: "text-left",
                                    Header: "Job",
                                    accessor: "job",
                                    Cell: ({ original }) => (original.job ? original.job : "<All Jobs>")
                                },
                                {
                                    headerClassName: "text-left",
                                    Header: "Product",
                                    accessor: "product",
                                    Cell: ({ original }) => (original.product ? original.product : "<All Products>")
                                },
                                {
                                    headerClassName: "text-left",
                                    Header: "Service Type",
                                    accessor: "serviceType",
                                    Cell: ({ original }) => (original.serviceType ? original.serviceType : "<All Service Types>")
                                },
                                {
                                    headerClassName: "text-left",
                                    Header: "Start Date",
                                    accessor: "startDate",
                                    // accessor: original => moment(original.startDate),
                                    Cell: ({ original }) => (original.startDate
                                        ? moment(original.startDate).format("YYYY-MM-DD")
                                        : "<No Start Date>")
                                },
                                {
                                    headerClassName: "text-left",
                                    Header: "End Date",
                                    accessor: "endDate",
                                    // accessor: original => moment(original.endDate),
                                    Cell: ({ original }) => (original.endDate
                                        ? moment(original.endDate).format("YYYY-MM-DD")
                                        : "<No End Date>")
                                },
                                {
                                    headerClassName: "text-left",
                                    Header: "Flat Rate",
                                    accessor: "rateFlat",
                                    // accessor: original => `$${original.rateFlat}`
                                    Cell: ({ original }) => `$${original.rateFlat}`
                                },
                                {
                                    headerClassName: "text-left",
                                    Header: "Per Hour Rate",
                                    accessor: "ratePerHour",
                                    // accessor: original => `$${original.ratePerHour}`
                                    Cell: ({ original }) => (`$${original.ratePerHour}`)
                                },
                                {
                                    Header: "Actions",
                                    id: "actions",
                                    className: "d-flex justify-content-center align-items-center",
                                    Cell: ({ original }) => (
                                        <ButtonGroup>
                                            <Button
                                                size="sm"
                                                onClick={() =>
                                                    this.handleModalSinglePayRateOverrides(
                                                        original.payRateOverrideID
                                                    )
                                                }
                                            >
                                                <FontAwesomeIcon icon="pen" title="Update" />
                                            </Button>
                                            <Popconfirm
                                                title={`Delete "${original.payRateOverrideID}"?`}
                                                onConfirm={() => this.handleDelete(
                                                    original.employeeId,
                                                    original.payRateOverrideID
                                                )}
                                                placement="bottomRight"
                                                okText="Yes"
                                                cancelText="Cancel"
                                            >
                                                <Button variant="danger" size="sm">
                                                    <FontAwesomeIcon icon="times" />
                                                </Button>
                                            </Popconfirm>
                                        </ButtonGroup>
                                    ),
                                    filterable: false,
                                    width: 100
                                }
                            ]}
                            pageSize={Math.max(10, payRateOverrides.length)}
                            className="-striped -highlight w-100"
                            showPagination={false}
                            style={{
                                // height: "calc(100vh - 240px)",
                                height: 300
                            }}
                        />
                    </div>
                : null}
            </div>
        );
    }
}

TabWorkerPayroll.defaultProps = {
    isEditable: false,
};

TabWorkerPayroll.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isEditable: PropTypes.bool
};

const mapStateToProps = state => ({
    loading: state.workersMaintenance.loading,
    payRateOverrides: state.workersMaintenance.payRateOverrides,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    getPayRateOverrides: bindActionCreators(getPayRateOverrides, dispatch),
    deletePayRateOverrideSingle: bindActionCreators(deletePayRateOverrideSingle, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabWorkerPayroll);
